// extracted by mini-css-extract-plugin
var _1 = "Form_fluid__12b8e";
var _2 = "Form_horizontal__43404";
var _3 = "Form_vertical__e9b1b";
export { _1 as "fluid", _2 as "horizontal", _3 as "vertical" }
